import React, { Component } from "react"
import { Accordion, Row, Col, Container } from "react-bootstrap"
import OrderResultRecord from "../../../api/OrderResults/OrderResultModel/OrderResultRecord"
import ServiceDetails from "../../../api/OrderResults/OrderResultModel/ServiceDetails"

import SchedulingCard from "./Cards/SchedulingCard"
import CollectionCard from "./Cards/CollectionCard"
import ExamDetailCard from "./Cards/ExamDetailCard"
import ExamResultDetailCard from "./Cards/ExamResultDetailCard"
import BATAlcoholTestCard from "./Cards/BATAlcoholTestCard"
import BATResultCard from "./Cards/BATResultCard"
import TestingCard from "./Cards/TestingCard"
import ReviewCard from "./Cards/ReviewCard"
import TestScreeningCard from "./Cards/TestScreeningCard"

interface TestStepsProps {
  currentRowInfo: OrderResultRecord,
  currentServiceInfo: ServiceDetails,
  isOnTrack?: boolean
}
export default class TestSteps extends Component<TestStepsProps, {}> {
  render = () => {
    const {currentRowInfo, currentServiceInfo, isOnTrack} = this.props
    const EventData = currentServiceInfo.EventData

    // TODO: the logic for constants below was ported from Angular application and *probably* will need to be refactored
    const isCollection = currentRowInfo.TestType === "Drug" || currentServiceInfo.IsClinical
    const isExamDetail = currentRowInfo.TestType === "Physical"
    const isAlcohol = currentRowInfo.TestType === "Alcohol"
    const isTesting = (currentServiceInfo.TestTypeDescription !== "Alcohol" && currentRowInfo.TestType === "Drug") || currentServiceInfo.IsClinical
    const isReview = currentServiceInfo.TestTypeDescription !== "Alcohol" && currentRowInfo.TestType === "Drug"
    const isTestScreening = currentServiceInfo.TestTypeDescription === "Alcohol" && currentRowInfo.TestType === "Drug"
    const isCovid = (currentRowInfo.TestDetailClinicalID || "").length > 0

    return (
      <Container className="test-steps px-3 pb-2">
        <Row>
          <Col><h5 className="pt-3 pb-2">TEST STEPS</h5></Col>
        </Row>
        <Row>
          <Col>
            <Accordion>
              <SchedulingCard data={currentServiceInfo} />
              { isCollection && <CollectionCard data={currentServiceInfo} /> }
              { isExamDetail && <ExamDetailCard data={currentServiceInfo} /> }
              { isExamDetail && <ExamResultDetailCard data={currentServiceInfo} /> }
              { isAlcohol && <BATAlcoholTestCard data={currentServiceInfo} /> }
              { isAlcohol && <BATResultCard data={currentServiceInfo} /> }
              { isTesting && <TestingCard data={currentServiceInfo} isCovid={isCovid}/> }
              { isReview && !isOnTrack && <ReviewCard data={currentServiceInfo} /> }
              { isTestScreening && <TestScreeningCard data={currentServiceInfo} /> }
            </Accordion>
          </Col>
        </Row>
      </Container>
    )
  }
}
